import kgIcon from 'assets/img/kg.png';
import enImg from 'assets/img/lang/en.png';
import ruImg from 'assets/img/lang/ru.png';
import uzImg from 'assets/img/lang/uz.png';
import TJKIcon from 'assets/img/TJKIcon.png';

export const langs = [
  {
    img: uzImg,
    text: 'o’zbek',
    lang: 'uz'
  },
  {
    img: ruImg,
    text: 'русский',
    lang: 'ru'
  },
  {
    img: enImg,
    text: 'english',
    lang: 'en'
  },
  {
    img: TJKIcon,
    text: 'тоҷикӣ',
    lang: 'tj'
  },
  {
    img: kgIcon,
    text: 'кыргыз',
    lang: 'ky'
  }
];
